import { useHardRedirect } from "./useHardRedirect"

/**
 * Return a function that will reload app on redirect
 */
export const useRedirectHard = () => {
    return useHardRedirect()
}